module.exports = __webpack_public_path__ + "img/musicz_agi.15207577.jpg";